var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"affiliate-link"},[_c('h2',[_vm._v("アフィリエイトリンク・特典設定")]),_c('el-row',[_c('el-col',[_c('PrivilegeConfig')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }